export default "__VITE_ASSET__CPr3vAaN__"